// extracted by mini-css-extract-plugin
export default {"developmentView":"DevelopmentView_developmentView__ncXqU"};